import filters from 'data/filters';

function fixUrlDecoding(pathWithQuery: string) {
  const [path, queryString] = pathWithQuery.split('?');
  const params = new URLSearchParams(queryString);
  if (params.has('k')) {
    let fixedQueryString = '';
    params.forEach((value, name) => {
      if (!filters.find(({ queryName }) => queryName === name)) {
        fixedQueryString += `&${name}=${value.split(' ').join('+')}`;
        return;
      }
      fixedQueryString += `&${name}=${encodeURI(value)}`;
    });
    return `${path}?${fixedQueryString.replace('&', '')}`;
  }
  return pathWithQuery;
}

export default fixUrlDecoding;
